<article>
  <div class="tabview-list">
    <div [class.active]="tabIndex === 0" (click)="tabIndex = 0"><i class="mdi mdi-view-list"></i> Categories</div>
    <div></div>
  </div>

  <table class="table table-hover table-striped">
    <thead>
      <tr>
        <th>Title</th>
        <th>Notes</th>
        <th title="">#</th>
      </tr>
    </thead>
    <tbody>
      @for (item of categories; track item) {
        <tr>
          <td>{{ item.title }}</td>
          <td [innerHTML]="item.notes"></td>
          <td>-</td>
        </tr>
      }
    </tbody>
  </table>

  <div class="text-right">
    <app-button label="Create Category" icon="mdi mdi-account-plus" styleClass="mt-1" (click)="create()"> </app-button>
  </div>

  @if (isShowingDialog()) {
    <app-dialog [header]="Category" [dimensions]="{ width: 500, height: 456 }" (onClose)="isShowingDialog.set(false)">
      <app-dialog-setpoint-template-category [category]="category" (onClose)="onClose($event)" />
    </app-dialog>
  }

  <!--
  <p-tabPanel [cache]="true">
    <ng-template pTemplate="header">
      Services
    </ng-template>
    <ng-template pTemplate="content">
      <table class="table table-hover table-striped">
        <thead>
          <tr>
            <th>Title</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of servicesForTenants" (click)="editServiceForTenants(item)">
            <td>{{item.title}}</td>
            <td [innerHTML]="item.notes"></td>
          </tr>
        </tbody>
      </table>

      <div class="text-right">
        <app-button label="Create Service" icon="mdi mdi-account-plus" styleClass="mt-1"
          (click)="createServiceForTenant()">
        </app-button>
      </div>
    </ng-template>
  </p-tabPanel>
  -->
</article>
